import { Injectable } from '@angular/core'

export enum UserStateType {
  state = 'state',
  address = 'address',
  ssn_dob = 'ssn_dob',
  ssn = 'ssn',
  dob = 'dob',
  mobile = 'mobile',
  isBlockedById = 'isBlockedById',
  preApproved = 'preApproved',
  minLoanAmount = 'minLoanAmount',
  maxLoanAmount = 'maxLoanAmount',
  minRequiredAmount = 'minRequiredAmount',
  lessStateAmount = 'lessStateAmount',
  lessStateAmountAfter = 'lessStateAmountAfter',
  noSelectedDentist = 'noSelectedDentist'
}

@Injectable({
  providedIn: 'root',
})
export class UserStateService {
  isInvalidStateAmount = false
  isInvalidState = false
  mobileCounter = 0

  // state, address, ssn_dob, dob, mobile
  type: UserStateType = UserStateType.state
}
